// ------------------------------------------------------------

import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import VideoPlayer from './DemosComponents/VideoPlayer';
import ScheduleDemoForm from './ScheduleDemoForm';
import PendingAccessPage from './Pages/PendingAccessPage';
import Page from './Page';
import { useAuth } from './Context/AuthContext';
import { Notification } from './Notification/Notification';

const StorylaneDemo = () => {
    const [currentDemo, setCurrentDemo] = useState(null);
    const [showScheduleForm, setShowScheduleForm] = useState(false);
    const [isVideoLoading, setIsVideoLoading] = useState(false);
    const navigate = useNavigate();
    const { userData, user, isAuthenticated } = useAuth();

    const [alert, setAlert] = useState(false);
    const [alertContent, setAlertContent] = useState('');
    const [alertType, setAlertType] = useState('');
    const handleAlert = () => {
        setAlert(false);
    };

    // Access gating — handle all access_status states
    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/login');
            return;
        }
        // Admins skip access_status gating entirely
        if (user?.role === 'admin') return;
        if (user?.access_status === 'none') {
            navigate('/request-demos');
        }
        // 'pending' → render PendingAccessPage inline (handled in JSX)
        // 'approved' | 'partial' | 'rejected' → normal dashboard render
    }, [isAuthenticated, user, navigate]);

    const handleScheduleSubmit = (scheduleData) => {
        console.log('📅 Complete schedule data:', {
            ...userData,
            ...scheduleData,
            selectedDemo: currentDemo?.title
        });

        // Use your custom notification system instead of alert()
        setAlertContent(`Demo "${currentDemo?.title}" scheduled successfully!`);
        setAlertType('success');
        setAlert(true);
        setShowScheduleForm(false);
    };

    // Show pending screen inline when access is awaiting review (not for admins)
    if (user?.role !== 'admin' && user?.access_status === 'pending') {
        return (
            <Page title="Inteliconvo">
                <PendingAccessPage />
            </Page>
        );
    }

    return (
        <Page title="Inteliconvo">
            <Box sx={{ display: 'flex', height: '95vh', overflow: 'hidden' }}>

                {/* Right Video Player Component */}
                <VideoPlayer
                    currentDemo={currentDemo}
                    onScheduleDemo={() => setShowScheduleForm(true)}
                    isLoading={isVideoLoading}
                />

                {/* Schedule Demo Form */}
                <ScheduleDemoForm
                    open={showScheduleForm}
                    onClose={() => setShowScheduleForm(false)}
                    onSubmit={handleScheduleSubmit}
                    userData={userData}
                    selectedDemo={currentDemo}
                    setAlertContent={setAlertContent}
                    setAlertType={setAlertType}
                    setAlert={setAlert}
                />
                {/* </Box> */}
                <Notification
                    open={alert}
                    message={alertContent}
                    type={alertType}
                    handleClose={handleAlert}
                />
            </Box>
            {/* </Grid> */}
            {/* </Grid> */}
        </Page>
    );

};

export default StorylaneDemo;
